import Cookies from "js-cookie";
import { fireEvent } from "@/scripts/common/util";

document.addEventListener("DOMContentLoaded", () => {
  const overlayUrl = window.__APP__.pageOverlayUrl;
  const overlayCookie = window.__APP__.pageOverlayCookie;

  if (overlayUrl) {
    fireEvent("modal:open", document.documentElement, {
      type: "content",
      url: overlayUrl,
    });

    if (overlayCookie) {
      Cookies.set("app_page_overlay_seen", "true", { expires: 1 });
    }
  }
});
